import { Typography } from "@mui/material";
import logo from "../img/image-Photoroom (1).png";
import React from "react";

const ElectricPlantBill = ({ data, reporteRef }) => {
  const sectionStyle = {
    borderBottom: "1px solid black",
  };
  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    fontSize: "10px",
    border: "1px solid black",
    width: `${350 * 3.78}px`,
    height: `${450 * 3.78}px`,
    boxSizing: "border-box",
  };

  const preprocessDescription = (description, maxChars = 20) => {
    const words = description[0]?.split(" ");
    let currentLine = "";
    const lines = [];

    words?.forEach((word) => {
      if (currentLine.length + word.length + 1 <= maxChars) {
        currentLine += (currentLine ? " " : "") + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    });

    if (currentLine) {
      lines?.push(currentLine);
    }
    return lines?.join("\n");
  };

  const printValueByQuestionName = (questionName) => {
    return (
      data.schedule_checklists
        .filter((checklist) => {
          const question = data?.questions.find(
            (q) =>
              q.id === checklist.checklist_question_id &&
              q.question === questionName
          );
          return (
            question?.service_type === data?.service_type && checklist.notes
          );
        })
        .map((item) => item.notes)[0]
        ?.toUpperCase() ?? "N/A"
    );
  };

  const date = new Date(data?.start_time);

  // Format the date as MM/DD/YY
  const formattedDate = `${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date
    .getFullYear()
    .toString()
    .slice(-2)}`;

  return (
    <div style={containerStyle} ref={reporteRef}>
      {/* logo sectio */}
      <div
        style={{
          display: "flex",
          alignContent: "center",
          borderBottom: "1px solid black",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ width: "180px", height: "100px" }}
        />
        <h1
          style={{
            fontSize: "30px",
            alignContent: "space-evenly",
            marginLeft: "8%",
          }}
        >
          CHECK LIST MANTENIMIENTO PLANTA ELECTRICA
        </h1>
      </div>
      {/* consecutive info  */}
      <div style={sectionStyle}>
        <Typography variant="h6" fontWeight={"bold"}>
          CONSECUTIVO: {data?.id}{" "}
        </Typography>
      </div>
      {/* client info  */}
      <div style={sectionStyle}>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "40%",
            }}
          >
            <div style={{ display: "flex" }}>
              <Typography variant="h6" style={{ marginRight: "20px" }}>
                FECHA:
              </Typography>
              <Typography variant="h6" style={{ marginRight: "20px" }}>
                {formattedDate}
              </Typography>
            </div>
            <div style={{ display: "flex" }}>
              <Typography variant="h6" style={{ marginRight: "20px" }}>
                TELEFONO:
              </Typography>
              <Typography variant="h6">{data.client_phone}</Typography>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
              <Typography variant="h6" style={{ marginRight: "20px" }}>
                CLIENTE Y SEDE:
              </Typography>
              <Typography variant="h6">{data.place}</Typography>
            </div>
            <div style={{ display: "flex" }}>
              <Typography variant="h6" style={{ marginRight: "20px" }}>
                CONTACTO:
              </Typography>
              <Typography variant="h6">{data.client_phone}</Typography>
            </div>
          </div>
        </div>
      </div>

      {/* first section data */}
      <div style={sectionStyle}>
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  borderLeft: "1px solid black",
                  borderBottom: "1px solid black",
                  width: "240px",
                }}
              >
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MARCA MOTOR
                </Typography>
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MODELO/SERIE
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("marca motor")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("modelo/serie")}
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  borderLeft: "1px solid black",
                  borderBottom: "1px solid black",
                  width: "240px",
                }}
              >
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MARCA GENERADOR
                </Typography>
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MODELO/SERIE
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("marca generador")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("modelo/serie generador")}
                  </Typography>
                </div>
              </div>
            </div>

            <div style={{ display: "flex" }}>
              <div
                style={{
                  borderLeft: "1px solid black",
                  width: "240px",
                }}
              >
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MODULO CONTROL
                </Typography>
                <Typography variant="h6" style={{ marginRight: "20px" }}>
                  MODELO SERIE
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("modulo control")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("modulo/serie modulo control")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  borderBottom: "1px solid black",
                  width: "140px",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ marginTop: "40px", textAlign: "center" }}
                >
                  POTENCIA
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("potencia KW")} KW
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("potencia KVA")} KVA
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("potencia A")} A
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "140px",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ margin: "32px", textAlign: "center" }}
                >
                  HORAS
                </Typography>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "32px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("horas")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    FLUIDOS
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    ACEITE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    REFRIGERANTE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    COMBUSTIBLE %
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    NIVEL
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("aceite nivel")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("refrigerante nivel")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("combustible nivel")}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    ESTADO
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("aceite estado")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("refrigerante estado")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("combustible estado")}
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", marginTop: "10px" }}
                  >
                    BATERIA
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    REF
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("bateria referencia")}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    CANTIDAD
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("bateria cant")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* second section data */}

      <div style={sectionStyle}>
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    DESCRIPCION
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    CORREAS
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    RADIADOR
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    INTERCAMBIADOR
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    LIMPIEZA CUARTO
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    BUENO/MALO
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("correas")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("radiador")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("intercambiador")}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("limpieza cuarto")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "4px 10px 0 10px",
                      textAlign: "center",
                      textWrap: "nowrap",
                    }}
                  >
                    REFERENCIA SISTEMA DE FILTRACION
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    ACEITE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "240px",
                    marginBottom: "1px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    AIRE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    COMBUSTIBLE
                  </Typography>
                </div>
                <div
                  style={{
                    width: "240px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    REFRIGERANTE
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRight: "1px solid black",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "160px",
                    marginTop: "32px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "referencia sistema de filtracion aceite"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "160px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "referencia sistema de filtracion aire"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "160px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "referencia sistema de filtracion combustible"
                    )}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "160px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "referencia sistema de filtracion refrigerante"
                    )}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex", marginTop: "32px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    ESTADO DE ACCESORIOS
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    CARGADOR DE BATERIAS
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    PRECALENTADOR
                  </Typography>
                </div>
                <div
                  style={{
                    width: "280px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", marginRight: "1px" }}
                  >
                    OTROS
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    BIEN
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado accesorios cargador de baterias"
                    ) === "BUENO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "0 20px",
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "estado accesorios precalentador"
                    ) === "BUENO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "0 20px",
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName("estado accesorios otros") ===
                    "BUENO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    MAL
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado accesorios cargador de baterias"
                    ) === "MALO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "80px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "0 20px",
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "estado accesorios precalentador"
                    ) === "MALO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    width: "80px",
                    borderLeft: "1px solid black",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "0 20px",
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName("estado accesorios otros") ===
                    "MALO"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* observations */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          <Typography variant="h6">OBSERVACIONES</Typography>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          {preprocessDescription(data.description, 135)
            .split("\n")
            .map((line, index) => (
              <div
                key={index}
                style={{
                  borderBottom:
                    index !==
                      preprocessDescription(data.description, 135).split("\n")
                        .length -
                        1 && "1px solid black",
                  padding: "5px 0", // Optional: Adjust padding for better spacing
                }}
              >
                <Typography variant="h6">{line}</Typography>
              </div>
            ))}
        </div>
      </div>

      {/* section 3 */}
      <div style={sectionStyle}>
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "4px 0 0 93px", textAlign: "center" }}
                  >
                    TRANSFERENCIA
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                    backgroundColor:
                      printValueByQuestionName("tranferencia") === "MANUAL"
                        ? "#71767B"
                        : "",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    MANUAL
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                    backgroundColor:
                      printValueByQuestionName("tranferencia") === "MONOCUENTA"
                        ? "#71767B"
                        : "",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    MONOCUENTA
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    VOLTAJE GENERADOR
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    F-F {printValueByQuestionName("voltaje generador f-f")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    N-T{printValueByQuestionName("voltaje generador n-t")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    HZ {printValueByQuestionName("voltaje generador hz")}
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "32px",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "180px",
                    backgroundColor:
                      printValueByQuestionName("tranferencia") === "AUTOMATICA"
                        ? "#71767B"
                        : "",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    AUTOMATICA
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                    backgroundColor:
                      printValueByQuestionName("tranferencia") === "MULTICUNETA"
                        ? "#71767B"
                        : "",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    MULTICUNETA
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    VOLTAJE
                    <br /> RED
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    F-F {printValueByQuestionName("voltaje red f-f")}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    N-T {printValueByQuestionName("voltaje red n-t")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    HZ {printValueByQuestionName("voltaje red hz")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "4px 30px 0 30px",
                      textAlign: "center",
                      textWrap: "nowrap",
                    }}
                  >
                    LECTURAS MOTOR
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    PRESION
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                    marginBottom: "1px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    TEMPERATURA
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    RPM
                  </Typography>
                </div>
                <div
                  style={{
                    width: "186px",
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    FUGAS
                  </Typography>
                </div>
                <div
                  style={{
                    width: "186px",
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    COLOR HUMO
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRight: "1px solid black",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "75px",
                    marginTop: "32px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName("lecturas motor presion")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "75px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName("lecturas motor temperatura")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "75px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName("lecturas motor rpm")}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "75px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName("sistema de escape fugas")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "75px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName("sistema de escape color humo")}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: "flex", marginTop: "32px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    SISTEMAS DE PROTECCION
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    PRESION
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    width: "280px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    TEMPERATURA
                  </Typography>
                </div>
                <div
                  style={{
                    width: "280px",
                    borderBottom: "1px solid black",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", marginRight: "1px" }}
                  >
                    VELOCIDAD
                  </Typography>
                </div>
                <div
                  style={{
                    width: "280px",
                    borderBottom: "1px solid black",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", marginRight: "1px" }}
                  >
                    REFRIGERANTE
                  </Typography>
                </div>
                <div
                  style={{
                    width: "280px",
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ textAlign: "center", marginRight: "1px" }}
                  >
                    ARRANQUE
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    BIEN
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName(
                      "sistemas de proteccion presion"
                    ) === "BIEN"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion temperatura"
                    ) === "BIEN"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion velocidad"
                    ) === "BIEN"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion refrigerante"
                    ) === "BIEN"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion arranque"
                    ) === "BIEN"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    MAL
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography variant="h6" style={{ textAlign: "center" }}>
                    {printValueByQuestionName(
                      "sistemas de proteccion presion"
                    ) === "MAL"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion temperatura"
                    ) === "MAL"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion velocidad"
                    ) === "MAL"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "45px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion refrigerante"
                    ) === "MAL"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
                <div
                  style={{
                    width: "45px",
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {printValueByQuestionName(
                      "sistemas de proteccion arranque"
                    ) === "MAL"
                      ? "☑"
                      : "-"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      margin: "4px 82px 0 82px",
                      textAlign: "center",
                      textWrap: "nowrap",
                    }}
                  >
                    VOLTAJE BATERIA
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    APAGADO
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                    marginBottom: "1px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    ARRANQUE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    MARCHA
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "140px",
                    marginTop: "32px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("voltaje bateria apagado")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("voltaje bateria arranque")}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName("voltaje bateria marcha")}
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                      textWrap: "nowrap",
                      marginLeft: "20px",
                      marginTop: "4px",
                    }}
                  >
                    ESTADO SIST. DE COMBUSTIBLE
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    MANGUERAS
                  </Typography>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    borderLeft: "1px solid black",
                    width: "186px",
                    marginBottom: "1px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    GOBERNADOR
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "186px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    FUGAS
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "140px",
                    marginTop: "32px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado sistema de combustible mangueras"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado sistema de combustible gobernador"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "140px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado sistema de combustible fugas"
                    )}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section 4 */}
      <div style={sectionStyle}>
        <div style={{ display: "flex" }}>
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      textAlign: "center",
                      textWrap: "nowrap",
                      marginTop: "4px",
                      marginLeft: "20px",
                    }}
                  >
                    ESTADO CONEXIONES ELECTRICAS
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ textWrap: "nowrap" }}>
                    MOD. CONTROL
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    GENERADOR
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    PMG
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    AVR
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography variant="h6" style={{ margin: "0 20px" }}>
                    ARNES
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "32px",
                }}
              >
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado conexiones electricas modulo control"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado conexiones electricas generador"
                    )}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado conexiones electricas pmg"
                    )}
                  </Typography>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado conexiones electricas avr"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    borderLeft: "1px solid black",
                    borderRight: "1px solid black",
                    width: "180px",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ margin: "0 20px", textAlign: "center" }}
                  >
                    {printValueByQuestionName(
                      "estado conexiones electricas arnes"
                    )}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                borderLeft: "1px solid black",
                boxSizing: "border-box",
              }}
            >
              <Typography variant="h6" style={{ margin: "0 20px" }}>
                TRABAJOS REALIZADOS:
              </Typography>
              {preprocessDescription(data.work_done, 200)
                .split("\n")
                .map((line, index) => (
                  <div
                    key={index}
                    style={{
                      borderBottom:
                        index !==
                          preprocessDescription(data.work_done, 200).split("\n")
                            .length -
                            1 && "1px solid black",
                      padding: "5px 0", // Optional: Adjust padding for better spacing
                    }}
                  >
                    <Typography variant="h6">{line}</Typography>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* firmas */}
      <div
        style={{
          display: "flex",
          height: "344px",
          justifyContent: "space-between",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        {/* Sección Firma Cliente */}
        <div
          style={{
            flex: "1",
            textAlign: "center",
            boxSizing: "border-box",
            padding: "0 10px",
            width: "49%",
          }}
        >
          <Typography
            variant="h6"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            Firma Cliente
          </Typography>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "100%",
              height: "150px",
              alignItems: "center",
              marginTop: "5px",
            }}
          >
            {data.signature_url ? (
              <img
                src={data.signature_url}
                alt="Client Signature"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
                crossOrigin="anonymous"
              />
            ) : (
              <Typography
                variant="body2"
                style={{ fontSize: "12px", color: "#aaa" }}
              >
                Sin Firma
              </Typography>
            )}
            <div style={{ display: "flex", flexDirection: 'column' }}>
              <Typography
                variant="h6"
                style={{ fontSize: "14px", margin: "5px 0" }}
              >
                Nombre: {data.person_name}
              </Typography>
              <Typography
                variant="h6"
                style={{ fontSize: "14px", margin: "5px 0" }}
              >
                C.C: {data.document}
              </Typography>
            </div>
          </div>
        </div>
        <div
          style={{ backgroundColor: "black", width: "1px", height: "346px" }}
        ></div>
        {/* Sección Firma Técnico */}
        <div
          style={{
            flex: "1",
            textAlign: "center",
            boxSizing: "border-box",
            padding: "0 10px",
            width: "49%",
          }}
        >
          <Typography
            variant="h6"
            style={{
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            Firma Técnico
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "100%",
              height: "150px",
              alignItems: "center",
              marginTop: "5px",
            }}
          >
            {data.technicianSignature ? (
              <img
                src={data.technicianSignature}
                alt="Technician Signature"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <Typography
                variant="body2"
                style={{ fontSize: "12px", color: "#aaa" }}
              >
                Sin Firma
              </Typography>
            )}
            <div style={{ display: "flex", flexDirection: 'column' }}>
              <Typography
                variant="h6"
                style={{ fontSize: "14px", margin: "5px 0" }}
              >
                Nombre: {data.user?.name}
              </Typography>
              <Typography
                variant="h6"
                style={{ fontSize: "14px", margin: "5px 0" }}
              >
                C.C: {data.user?.document}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElectricPlantBill;
